module.exports = __webpack_public_path__ + "img/trash-can-xmark.f6fe0c57.svg";